var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "waterfall", staticClass: "water-fall wf-wrap" },
    [
      _c(
        "ul",
        [
          _c(
            "transition-group",
            { attrs: { name: "list", tag: "li" } },
            _vm._l(_vm.waterfallList, function (item) {
              return _c(
                "li",
                {
                  key: item.grp_id,
                  staticClass: "wf-item",
                  style: {
                    top: item.top + "px",
                    left: item.left + "px",
                    width: item.width + "px",
                    height: item.height + "px",
                  },
                },
                [
                  _c("img", {
                    attrs: { src: item.src },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.clickImage.apply(null, arguments)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.$route.path.includes("person/collection")
                    ? _c(
                        "div",
                        {
                          staticClass: "check-box",
                          class: { checked: _vm.isChecked(item) },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.selectImage(item)
                            },
                          },
                        },
                        [_c("i", { staticClass: "el-icon-check" })]
                      )
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.waterfallList.length && !_vm.loading
        ? _c(
            "flex",
            {
              staticClass: "no_data",
              attrs: { align: "center", justify: "center" },
            },
            [_vm._v("\n    暂无数据...\n  ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }